import React, {Component} from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  Input,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import {Add, CloudDownload, Delete, Done} from "@material-ui/icons";
import localization from "../../config/localization";
import AsyncSelect from "react-select/lib/Async";
import {request} from "../../api-client";
import browserHistory from "../../utils/browserHistory";
import GlobalSnackbar from "../../components/Letflow/Snackbar/GlobalSnackbar";
import {getUpdateFormImageUrlFromItem, makeFitImageUrlWithSize, validateEmail} from "../../utils";
import FilePondUploader from "../../components/Letflow/FilePondUploader";
import InputLabel from "@material-ui/core/InputLabel";
import {ImagePicker} from "../../components/Letflow/Form";
import Unsplash from "../../components/Letflow/Unsplash";
import {get} from 'lodash';

class InviteExternalUsers extends Component {
  state = {
    current: ""
  };

  isValid = () => validateEmail(this.state.current) && !this.props.emails.includes(this.state.current);

  onAddClick = () => {
    this.props.onEmailsChange(this.props.emails.concat([this.state.current]));
    this.setState({ current: "" });
  };

  onRemoveClick = email => {
    this.props.onEmailsChange(this.props.emails.filter(x => x !== email));
  };

  render = () => (
    <InviteExternalUsersView
      current={this.state.current}
      onCurrentChange={current => this.setState({ current })}
      emails={this.props.emails}
      addButtonDisabled={!this.isValid()}
      onAddClick={this.onAddClick}
      onRemoveClick={this.onRemoveClick}
    />
  );
}

const InviteExternalUsersView = ({
  current,
  onCurrentChange,
  emails,
  onAddClick,
  onRemoveClick,
  addButtonDisabled
}) => {
  return (
    <section style={{ marginBottom: 30 }}>
      <h4>{localization.get("create_pitch.invite_external_users")}</h4>
      <p>
        {localization.get("create_pitch.invite_external_users_explanation")}
      </p>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Input
          style={{ flexBasis: "calc(100% - 50px)", marginRight: 10 }}
          value={current}
          onChange={e => onCurrentChange(e.target.value)}
        />
        <IconButton
          style={{ width: 24, height: 24 }}
          onClick={onAddClick}
          disabled={addButtonDisabled}
        >
          <Add onClick={onAddClick} />
        </IconButton>
      </div>
      <div style={{ height: 10 }} />
      <h4>{localization.get("create_pitch.added_external_users")}</h4>
      {emails.map((x, i) => (
        <SelectedUserView key={i} name={x} onRemove={() => onRemoveClick(x)} />
      ))}
      {emails.length === 0 && (
        <p>{localization.get("create_pitch.no_external_users_added")}</p>
      )}
    </section>
  );
};

const SelectedUserView = ({ name, isAdmin, onAdminChange, onRemove }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <Done style={{ marginRight: 10, color: "green" }} />
      <span>{name}</span>
    </div>
    <div style={{ display: "flex", alignItems: "center" }}>
      {onAdminChange && (
        <React.Fragment>
          <span>{localization.get("pitches.pitch_admin")}</span>
          <input
            type="checkbox"
            value={isAdmin}
            onChange={() => onAdminChange(!isAdmin)}
          />
        </React.Fragment>
      )}
      <IconButton style={{ width: 24, height: 24 }} onClick={onRemove}>
        <Delete style={{ fontSize: 17 }} />
      </IconButton>
    </div>
  </div>
);

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectName: "",
      projectDetails: "",
      firstMessage: "",
      submitting: false,
      usersToSelect: [],
      users: [],
      imageId: "",
      image: { id: null, src: null, file: null },
      disableForm: false,
      profileImageRadio: "filepond",
      unsplashProfileImage: '',
    };
  }

  componentDidMount = () => {
    document.getElementsByTagName("html")[0].scrollTop = 0;
  }

  formNewUrl = (path) =>  process.env.REACT_APP_CDN_HOST.concat('/' + path)
  onSetProfileImageFromUnsplash = (url, name) => this.setState({unsplashProfileImage: {url, name}})

  render = () => {
    const onImageChange = image => image ? this.setState({imageId: image.id, image: {src: null, filename: null }, imagePreview: this.formNewUrl(image.path)}) : this.setState({imageId: null, image: { src: null, filename: null }})
    const setPreview = () => {
        let item = {image: {id: this.state.imageId, src: this.state.imagePreview}}
        this.setState({image : {src: getUpdateFormImageUrlFromItem(item)}})
    }

    return (
      <div style={{ display: "flex", justifyContent: "center", padding:"2% 10%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: 700
          }}
        >
          <this.Title />
          <this.Subtitle localizationKey="fill_pitch_details" />
          <this.ProjectName />
          <this.ProjectDetails />
          <this.Subtitle localizationKey="select_pitch_users" />
          <AsyncSelect
            styles={{
              menu: base => ({
                ...base,
                zIndex: 10
              })
            }}
            theme={theme => ({
              ...theme,
              borderRadius: 0
            })}
            placeholder={localization.get('users')}
            loadingMessage={() => localization.get('loading')}
            value={this.state.users}
            noOptionsMessage={() => localization.get('no_options')}
            defaultOptions
            isMulti
            onChange={(e) => this.setState({users: e})}
            isClearable={true}
            formatOptionLabel={user => (
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <img src={user.image} width={25} height={25} alt="user-image" />
                <p style={{paddingTop: 5, paddingLeft: 10}}>{user.label}</p>
              </div>
            )}
            loadOptions={inputValue => {
              let filters = [
                {column: "name", filter: inputValue},
              ]

              return request.user.getAll({filterBy: filters})
                .then(users => users.map(user => ({
                  value: user.id,
                  label: user.name,
                  image: makeFitImageUrlWithSize(user.contentCreator || user, 'xs')
                })))
                .then(users => users.sort((a, b) => a.label.localeCompare(b.label)))
            }}
          />
          <br/>
          <br/>
          <InputLabel>{localization.get('project.image')}</InputLabel>
          <h4>{localization.get('form.select_image_profile')}</h4>
          <FormControl>
            <RadioGroup
              name="profileImageRadio"
              value={this.state.profileImageRadio}
              onChange={e => this.setState({profileImageRadio: e.target.value})}
              style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
            >
              <FormControlLabel value="filepond" control={<Radio color="default"/>}
                                label={localization.get('client_file.upload_from_computer')}/>
              <FormControlLabel value="unsplash" control={<Radio color="default"/>}
                                label={localization.get('form.upload_from_unsplash')}/>
            </RadioGroup>
          </FormControl>
          <br/>
          {this.state.profileImageRadio === 'filepond' ?
            <>
              {this.state.image && <ImagePicker image={this.state.image.src} previewOnly={true}/>}
              <FilePondUploader
                disableForm={this.state.disableForm}
                updateDisableForm={value => this.setState({disableForm: value})}
                file={this.state.image}
                id={"image"}
                type={"image"}
                allowedTypes={["image/*"]}
                onIdChange={onImageChange}
                setPreview={setPreview}
              />
            </>
            : this.state.profileImageRadio === 'unsplash' ?
              <Unsplash imageAmount={9} onSelectImage={this.onSetProfileImageFromUnsplash}/>
              : null
          }
          <this.SubmitButton />
        </div>
      </div>
    );
  }

  Title = () => <h1>{localization.get("pitches.create_pitch")}</h1>;

  Subtitle = ({ localizationKey }) => (
    <h4>{localization.get(localizationKey)}</h4>
  );

  ProjectName = () => (
    <this.TextFieldWrapper id="projectName" labelKey="pitches.project_name" />
  );

  ProjectDetails = () => (
    <this.TextFieldWrapper
      id="projectDetails"
      labelKey="pitches.project_details"
      multiline
    />
  );

  InitialMessage = () => (
    <this.TextFieldWrapper
      id="firstMessage"
      labelKey="pitches.first_message"
      multiline
    />
  );

  SubmitButton = () => {
    const { submitting, projectName, disableForm } = this.state;

    let disabled = submitting || projectName.length === 0 || disableForm;

    return (
      <div style={{ textAlign: "right" }}>
        <Button variant="contained" onClick={this.onSubmit} disabled={disabled}>{localization.get("send")}</Button>
      </div>
    );
  };

  TextFieldWrapper = ({ id, labelKey, multiline }) => (
    <TextField
      style={{ marginBottom: 20 }}
      id={id}
      label={localization.get(labelKey)}
      onChange={e => this.setState({ [e.target.id]: e.target.value })}
      multiline={multiline}
    />
  );

  onSubmit = async () => {
    this.setState({ submitting: true });

    const {
      users,
      projectDetails,
      projectName,
      firstMessage,
      imageId,
    } = this.state;

    const participants = users.map(x => ({ id: x.value, is_admin: 0 }));

    request.pitch.create({
        project_name: projectName,
        project_details: projectDetails,
        participants,
        first_message: firstMessage,
        imageId,
    }).catch(e => {
      console.log(e);
      GlobalSnackbar.showGenericError();
      this.setState({ submitting: false });
    }).then((response) => {
      GlobalSnackbar.showGenericSuccess();
      browserHistory.push(this.props.makeCreatedPitchPath(response.id));
    })
  };
}